// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"c3cff7eb","977":"cfc807f1"}[chunkId] + ".chunk.js";
};